// Available commands configuration
const AVAILABLE_COMMANDS = [
  {
    name: "Resume",
    command: "resume",
    description: "Download Nima Najaflou's resume",
  },
  {
    name: "Contact",
    command: "contact",
    description: "View contact information",
  },
  {
    name: "Projects",
    command: "projects",
    description: "View project portfolio with links",
  },
  {
    name: "Skills",
    command: "skills",
    description: "View technical skills",
  },
  {
    name: "Experience",
    command: "experience",
    description: "View work experience",
  },
  {
    name: "Education",
    command: "education",
    description: "View education background",
  },
  {
    name: "Clear",
    command: "clear",
    description: "Clear the terminal screen",
  },
  {
    name: "Help",
    command: "help",
    description: "Show available commands",
  },
];

export default AVAILABLE_COMMANDS;
